export default function Spinner() {
  return (
   <div className="loader small"></div>
  );
}
